import styled, { css } from 'styled-components';
import { GridMenuOptionImage, GridMenuOptionItemContainer } from '../../UIHelpersLUXE/GridMenu/GridMenu-styled';
import { TabContainer } from '../Tabs-styled';


export const StoneGroupSection = styled.div`
  margin-bottom: 20px;
`;

export const StonesSectionHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StonesSectionHeaderLeftSide = styled.div`
  margin-left: 3px;
`;

export const StonesSectionHeaderTopText = styled.div`
`;

export const StonesSectionHeaderBottomText = styled.div`
  font-weight: bold;
  text-transform: uppercase;
`;

export const StonesTabContainer = styled(TabContainer)`
  ${(props) => props.mobile && css`
    ${StonesSectionHeaderTopText} {
      font-size: ${12 * props.menuScaleFactor}px;
    };

    ${GridMenuOptionItemContainer} {
      font-size: ${10.88 * props.menuScaleFactor}px;
    }

    ${GridMenuOptionImage} {
      width: ${54.72 * props.menuScaleFactor}px;
      height: ${54.72 * props.menuScaleFactor}px;
      margin-bottom: 0px !important;
    };
  `}
`;